import { Circle, HStack } from "@chakra-ui/react";
import React from "react";

const ExamEllipses = ({
  examCorrection,
  answeredQ,
  questionsCount,
  setSelectedQuestionIdx,
  selectedQuestionIdx,
  accentColor,
}) => {
  const ring = accentColor || "main_1";
  const path = window.location.pathname;
  const isPath = () => path.includes("exam-result") || path.includes("study");
  const RightAnswerId = (index) => {
    if (path.includes("study")) {
      return examCorrection?.[index]?.answers?.find(
        (data) => data?.right_answer == 1
      )?.id;
    } else
      return examCorrection?.questions?.[index]?.answers?.find(
        (data) => data?.right_answer == 1
      )?.id;
  };

  return (
    <HStack flexWrap="wrap">
      {[...Array(questionsCount)]?.map((data, index) => {
        return (
          <Circle
            size="40px"
            cursor="pointer"
            bg={
              isPath()
                ? examCorrection?.answers
                  ? examCorrection?.answers[index]?.student_answer_id ==
                    RightAnswerId(index)
                    ? "green.400"
                    : "red.500"
                  : examCorrection?.[index]?.student_answers
                      ?.student_answer_id == RightAnswerId(index)
                  ? "green.400"
                  : !examCorrection?.[index]?.student_answers
                  ? "main_1"
                  : "red.500"
                : selectedQuestionIdx == index
                ? "white"
                : answeredQ?.includes(index.toString())
                ? "gray.400"
                : "red.500"
            }
            color={
              isPath()
                ? "white"
                : selectedQuestionIdx == index
                ? ring
                : "white"
            }
            border="2px solid"
            borderColor={
              selectedQuestionIdx == index
                ? ring
                : isPath()
                ? "rgba(255,255,255,0.4)"
                : answeredQ?.includes(index.toString())
                ? "green.400"
                : "red.300"
            }
            boxShadow={
              selectedQuestionIdx == index
                ? accentColor
                  ? `0 0 0 2px #fff, 0 0 0 4px ${accentColor}`
                  : "0 0 0 2px rgba(106, 30, 30, 0.2)"
                : undefined
            }
            fontWeight="800"
            fontSize="sm"
            onClick={() => setSelectedQuestionIdx(index)}
          >
            {index + 1}
          </Circle>
        );
      })}
    </HStack>
  );
};

export default ExamEllipses;
